import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                trigger: 'openSearch'
            }
        };
    }

    openSearch() {
        if (html.classList.contains('has-nav-open')) {
            this.call('close', null, 'Menu');
            setTimeout(() => this.call('open', null, 'SearchNav'), 600);
        } else {
            this.call('open', null, 'SearchNav');
        }
    }
}
